<template>

    <div class="has-text-centered">
        <div class="app-block p-md">
            <div>{{ $t('candidate.fees.bank_cb.description') }}</div>
            <div><strong>{{ $t('candidate.fees.bank_cb.security') }}</strong></div>

            <form :action="checkout.oEpt.sUrlPaiement" method="post" id="PaymentRequest">

                <input type="hidden" name="version" id="version" :value="checkout.oEpt.sVersion">
                <input type="hidden" name="TPE" id="TPE" :value="checkout.oEpt.sNumero">
                <input type="hidden" name="date" id="date" :value="checkout.sDate">
                <input type="hidden" name="montant" id="montant" :value="checkout.sMontant+checkout.sDevise">
                <input type="hidden" name="reference" id="reference" :value="checkout.sReference">
                <input type="hidden" name="MAC" id="MAC" :value="checkout.sMAC">
                <input type="hidden" name="url_retour" id="url_retour" :value="checkout.oEpt.sUrlRETOUR">
                <input type="hidden" name="url_retour_ok" id="url_retour_ok" :value="checkout.oEpt.sUrlOK">
                <input type="hidden" name="url_retour_err" id="url_retour_err" :value="checkout.oEpt.sUrlKO">
                <input type="hidden" name="lgue" id="lgue" value="FR"> <input type="hidden" name="societe" id="societe"
                                                                              :value="checkout.oEpt.sCodeSociete">
                <input type="hidden" name="texte-libre" id="texte-libre" :value="checkout.sTexteLibre">
                <input type="hidden" name="mail" id="mail" :value="checkout.sEmail">

                <hr>
                <div class="has-text-centered">
                    <button class="button button-valid">{{ $t('candidate.fees.bank_cb.button') }}
                    </button>
                </div>

            </form>
        </div>
    </div>

</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        data () {
            return {
                checkout: ''
            }
        },
        props: {
            candidate: { type: Object }
        },
        computed: {
            application () {
                return this.candidate.applications
            },
        },
        methods: {
            send: function () {
                this.$emit('send')
            }
        },
        created () {
            this.checkout = this.application.checkout
        }

    }
</script>